import { $, merge } from "glamor";
import theme from "styles/theme";

const itemWidth = "48%";

export const styles = {
    row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    item: {
        width: itemWidth,
        marginLeft: "1px",
    },
    clearIndicator: (provided: React.CSSProperties) => ({
        ...provided,
        cursor: "pointer",
    }),
    textField: {
        root: {
            width: itemWidth,
        },
        fieldGroup: {
            border: "none",
        },
    },
};

export const customStylesForAlert = merge(
    $(" .container", {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        padding: "1rem",
        borderRadius: "none",
    }),
    $(".severity", {
        border: "none",
    }),
    $(" .icon", {
        color: `${theme.palette.errorAlertTextColor}`,
        marginRight: "1rem",
        alignSelf: "center",
    }),
    $(" .result_message", {
        fontFamily: "Lato",
        fontSize: "1.2rem",
    }),
);
